export default __webpack_public_path__ + "static/media/Physicians Mutual Dark.906ff28a.svg";